export const UNASSIGNED_AUDIENCE_FILTER_ID = 'unassigned';
export const UNASSIGNED_AUDIENCE_FILTER_TYPE = 'UnassignedAudience' as const;
